/* tslint:disable */
/* eslint-disable */
/**
 * Bank Accounts API
 * API for managing bank accounts
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { BankAccountDto } from './BankAccountDto';
import {
    BankAccountDtoFromJSON,
    BankAccountDtoFromJSONTyped,
    BankAccountDtoToJSON,
    BankAccountDtoToJSONTyped,
} from './BankAccountDto';

/**
 * 
 * @export
 * @interface GetBankAccountResponseDto
 */
export interface GetBankAccountResponseDto {
    /**
     * Indicates if the operation was successful
     * @type {boolean}
     * @memberof GetBankAccountResponseDto
     */
    isSuccess: boolean;
    /**
     * Error message if the operation failed
     * @type {string}
     * @memberof GetBankAccountResponseDto
     */
    errorMessage?: string | null;
    /**
     * 
     * @type {BankAccountDto}
     * @memberof GetBankAccountResponseDto
     */
    bankAccount?: BankAccountDto;
}

/**
 * Check if a given object implements the GetBankAccountResponseDto interface.
 */
export function instanceOfGetBankAccountResponseDto(value: object): value is GetBankAccountResponseDto {
    if (!('isSuccess' in value) || value['isSuccess'] === undefined) return false;
    return true;
}

export function GetBankAccountResponseDtoFromJSON(json: any): GetBankAccountResponseDto {
    return GetBankAccountResponseDtoFromJSONTyped(json, false);
}

export function GetBankAccountResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetBankAccountResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'isSuccess': json['isSuccess'],
        'errorMessage': json['errorMessage'] == null ? undefined : json['errorMessage'],
        'bankAccount': json['bankAccount'] == null ? undefined : BankAccountDtoFromJSON(json['bankAccount']),
    };
}

export function GetBankAccountResponseDtoToJSON(json: any): GetBankAccountResponseDto {
    return GetBankAccountResponseDtoToJSONTyped(json, false);
}

export function GetBankAccountResponseDtoToJSONTyped(value?: GetBankAccountResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'isSuccess': value['isSuccess'],
        'errorMessage': value['errorMessage'],
        'bankAccount': BankAccountDtoToJSON(value['bankAccount']),
    };
}

